module.exports = __webpack_public_path__ + "static/media/omegamax13001.39d50a05.pdf";